module.exports = __webpack_public_path__ + "img/2019103003.fd8855f6.jpg";